import Vue from 'vue'
import router from './router';
import vuetify from "./plugins/vuetify";
import { i18n } from './plugins/i18n';
import VueSocialSharing from 'vue-social-sharing';
// import VueAnalytics from 'vue-analytics';

Vue.use(VueSocialSharing, {
    networks: {
        whatsapp: 'https://api.whatsapp.com/send?text=@t%0D%0A@d%0D%0A@u'
    }
});

const nombreCookie = process.env.NOMBRE_COOKIE ?? 'Observatorio-Urbano-Vinaros-Consentimiento';
Vue.mixin({
    data: function() {
        return {
            get nombreCookie() {
                return nombreCookie;
            }
        }
    }
});
// Vue.use(VueAnalytics, {
//     id: 'G-V0QXX4L9Y7',
//     router
// });

new Vue({
    vuetify,
    router,
    i18n,
    template: `<router-view/>`
}).$mount("#app");
